export default __webpack_public_path__ + "1608377abf023e03391b488db1fa43b9.jpg";